<template>
    <div>
        <div>
            <PageTitle :title="$t('eventos.titulo_buscar_abono')" class="strech"/>
            <FormBuscarAbonado />
        </div>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import FormBuscarAbonado from './FormBuscarAbonado.vue';


    export default {
        components: {
            PageTitle, FormBuscarAbonado
        },
        computed : {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
        },
    }
</script>